var map = {
	"./Coinsdataflow.jpeg": 244,
	"./Cointelegraph.jpeg": 245,
	"./Concerto-Logo.png": 246,
	"./EY.jpeg": 247,
	"./FinancialIT.jpeg": 248,
	"./IDS Fintech Logo/fintech logo/250-100px/fintech-logo---blue-type.png": 249,
	"./IDS Fintech Logo/fintech logo/250-100px/fintech-logo---white-type.png": 250,
	"./IDS Fintech Logo/fintech logo/800 verticl version/fintech-logo-blue-version.png": 251,
	"./IDS Fintech Logo/fintech logo/800 verticl version/fintech-logo-white-version.png": 252,
	"./IDS Fintech Logo/fintech logo/high Res horizontal/landscape-white-text.png": 253,
	"./ManageEngine.png": 254,
	"./NIIT.jpeg": 255,
	"./Neosoft.jpeg": 256,
	"./NewsAffinity.jpeg": 257,
	"./Payoneer.jpeg": 258,
	"./TEMENOS.png": 259,
	"./Vaccumlabs.jpg": 260,
	"./Watermelon.jpeg": 261,
	"./abaka.jpg": 262,
	"./africa.jpeg": 263,
	"./ambidextr.jpeg": 264,
	"./appway.png": 265,
	"./arabnet.jpeg": 266,
	"./aroundb.png": 267,
	"./avaya.png": 268,
	"./azentio.jpg": 269,
	"./backbase.jpeg": 270,
	"./backbase.png": 271,
	"./bankingcio.jpeg": 272,
	"./bankserv.jpg": 273,
	"./bc.jpeg": 274,
	"./beingcrypto.png": 275,
	"./bigdata.jpeg": 276,
	"./blocksocial.jpeg": 277,
	"./caia.jpeg": 278,
	"./cibe.jpeg": 279,
	"./coforge.jpg": 280,
	"./coinpedia.jpeg": 281,
	"./coinquora.png": 282,
	"./coinrepublic.png": 283,
	"./coinsflare.jpeg": 284,
	"./comarch.jpeg": 285,
	"./comforte_logo.png": 286,
	"./comviva.png": 287,
	"./confluent.jpg": 288,
	"./conrad.png": 289,
	"./consdata.jpeg": 290,
	"./creatio.png": 291,
	"./cryptoSaudi.png": 292,
	"./cryptonewz.jpeg": 293,
	"./daon.jpg": 294,
	"./darktrace.png": 295,
	"./difc.jpg": 296,
	"./difc.png": 297,
	"./edb.png": 298,
	"./expo.jpeg": 299,
	"./expo2020.png": 300,
	"./faloos.jpg": 301,
	"./findbiometrics.jpeg": 302,
	"./fintech.jpeg": 303,
	"./fintechfinance.jpeg": 304,
	"./fintechfutures.jpeg": 305,
	"./fintechgalaxy.jpeg": 306,
	"./fintechgalaxy.jpg": 307,
	"./fintechpower.jpeg": 308,
	"./fintechtimes.jpeg": 309,
	"./fireeye.png": 310,
	"./freshworks.png": 311,
	"./fss.png": 312,
	"./hcl.jpg": 313,
	"./hyperpay.jpeg": 314,
	"./ibm.jpeg": 315,
	"./ids.png": 316,
	"./ie.jpg": 317,
	"./igologic.jpg": 318,
	"./iib.jpeg": 319,
	"./infobip.jpeg": 320,
	"./infosys.jpg": 321,
	"./infrasoft.png": 322,
	"./investera.jpeg": 323,
	"./kissflow.jpg": 324,
	"./kitamo.jpeg": 325,
	"./maxut.png": 326,
	"./menafintech.jpeg": 327,
	"./microsoft.png": 328,
	"./mobileidworld.jpeg": 329,
	"./neosoft.png": 330,
	"./network.jpg": 331,
	"./newgen.png": 332,
	"./onespan.jpeg": 333,
	"./onespan.jpg": 334,
	"./openfactor.png": 335,
	"./oracle.jpeg": 336,
	"./oxford.png": 337,
	"./paypers.jpg": 338,
	"./piotech.png": 339,
	"./privatebanking.jpeg": 340,
	"./pwc.jpeg": 341,
	"./pwc.jpg": 342,
	"./rakbank.png": 343,
	"./recorded.png": 344,
	"./regtech.png": 345,
	"./scventure.jpg": 346,
	"./sinofy.png": 347,
	"./skiply.png": 348,
	"./smart.png": 349,
	"./smartmessage.png": 350,
	"./smartstream.jpeg": 351,
	"./smartstream.png": 352,
	"./tata.jpeg": 353,
	"./tcs.jpg": 354,
	"./telco.jpeg": 355,
	"./temenos.jpg": 356,
	"./threatLocker.jpg": 357,
	"./tripwire.jpeg": 358,
	"./truebanking.jpeg": 359,
	"./turbonomic.png": 360,
	"./ufg.png": 361,
	"./unlock.png": 362,
	"./yethi.png": 363
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41;